import React from 'react';
import MainLayout from '../components/layout/MainLayout';
import PatientHeader from '../components/patients/PatientHeader';
import TreatmentTimeline from '../components/patients/TreatmentTimeline';
import CurrentStatus from '../components/patients/CurrentStatus';
import KeyMetrics from '../components/patients/KeyMetrics';
import RecentNotes from '../components/patients/RecentNotes';
import RelatedKnowledge from '../components/patients/RelatedKnowledge';

const PatientView = () => {
  // Sample patient data
  const patient = {
    name: "John Doe",
    age: 58,
    gender: "Male",
    diagnosis: "Metastatic Colorectal Cancer",
  };

  return (
    <MainLayout 
      activeNavItem="dashboard"
      searchPlaceholder="Search: John Doe"
      notifications={3}
    >
      <div className="flex h-full">
        <div className="flex-1 p-6 overflow-auto">
          <PatientHeader patient={patient} />
          <TreatmentTimeline />
          <CurrentStatus />
          <KeyMetrics />
          <RecentNotes />
        </div>
        <div className="w-80">
          <RelatedKnowledge />
        </div>
      </div>
    </MainLayout>
  );
};

export default PatientView;